import { SegmentedMessage } from 'sms-segments-calculator'

import {
  MMS_CHARACTER_LIMIT,
  MMS_CREDIT_COUNT,
} from '../../constants/communication'
import { cn } from '../../utils/cn'

function SmsCharacterCountDisplay({
  isMMS,
  message,
}: {
  isMMS: boolean
  message: string
}) {
  function composeSmsCharacterDisplay() {
    const segment = new SegmentedMessage(message)

    return `${message.length} characters = ${
      isMMS ? MMS_CREDIT_COUNT : segment.segmentsCount
    } Credit(s)`
  }

  return (
    <p
      className={cn(
        isMMS && message.length > MMS_CHARACTER_LIMIT
          ? 'text-ion-color-danger'
          : 'text-ion-color-dark'
      )}
    >
      {composeSmsCharacterDisplay()}
    </p>
  )
}

export { SmsCharacterCountDisplay }
